import fetch from "axios";

const baseUrl = process.env.REACT_APP_API_ENDPOINT;
const baseConfig = {
    baseURL: baseUrl
};

const createInstance = config => {
    return fetch.create(config);
};

const instance = createInstance(baseConfig);

const fetchApi = {
    baseUrl,
    service() {
        return instance;
    }
};

export default fetchApi;
